import { takeLatest, put, call, fork, select } from 'redux-saga/effects';
import callApi from 'utils/api';
import * as types from './change-partner-constants';
import * as actions from './change-partner-actions';

export const getServiceCenterId = state => state.navigation.navigationSelf.serviceCenterId;

export function* getPartners(action) {
  try {
    const { type, entityId, query = '*' } = action.payload;
    const request = {
      query,
      filters: {
        partnerFunction: type,
        entityId,
      },
    };
    const serviceCenterId = yield select(getServiceCenterId);
    const results = yield call(callApi, {
      endpoint: `refdata/lookup/${serviceCenterId}/partner`,
      options: {
        method: 'POST',
        body: JSON.stringify(request),
        errorMessage: 'Could not fetch partners',
        retryAction: action,
      },
    });

    yield put(actions.getPartnersSuccess(results));
  } catch (err) {
    yield put(actions.getPartnersFailure(err));
  }
}

export function* savePartner(action) {
  try {
    const { order, addPartnerId, removePartnerId, isShipTo, cosmosId, isFlexible } = action.payload;
    const request = {
      details: order,
    };
    const results = yield call(callApi, {
      // eslint-disable-next-line
      endpoint: `info/update/order/${order.id}/partner?${addPartnerId ?
        `addPartnerId=${addPartnerId}` : ''}${removePartnerId ?
          `&removePartnerId=${removePartnerId}` : ''}${cosmosId ?
            `&flexiblePartnerId=${cosmosId}` : ''}${isFlexible ?
              `&isFlexible=${isFlexible}` : ''}`,
      options: {
        method: 'PUT',
        body: JSON.stringify(request),
        errorMessage: 'Could not change partner',
        retryAction: action,
      },
    });

    yield put(
      actions.savePartnerSuccess({ ...results, details: { order: results.details }, isShipTo }),
    );
  } catch (err) {
    yield put(actions.savePartnerFailure(err));
  }
}

export function* savePartnerDetails(action) {
  try {
    const {
      firstName,
      lastName,
      phoneNumber,
      email,
      number,
      description,
      street,
      houseNumber,
      city,
      regionKey,
      postalCode,
      partnerFunction,
      query = '*',
      entityId,
      guid,
    } = action.payload;
    const request = {
      data: {
        name: description,
        street,
        houseNumber,
        postalCode,
        city,
        regionKey,
        firstName,
        lastName,
        phoneNumber,
        email,
      },
      partnerFunction,
      query: {
        query,
        filters: {
          entityId,
          partnerFunction,
        },
      },
      entityId,
      guid,
    };
    const results = yield call(callApi, {
      endpoint: `info/update/partner/${number}`,
      options: {
        method: 'POST',
        body: JSON.stringify(request),
        errorMessage: 'Could not update partner',
        retryAction: action,
      },
    });

    yield put(actions.savePartnerDetailsSuccess(results));
  } catch (err) {
    yield put(actions.savePartnerDetailsFailure(err));
  }
}

export function* addPartnerDetails(action) {
  try {
    const {
      firstName,
      lastName,
      phoneNumber,
      email,
      partnerFunction,
      query = '*',
      entityId,
    } = action.payload;
    const request = {
      data: {
        firstName,
        lastName,
        phoneNumber,
        email,
      },
      partnerFunction,
      query: {
        query,
        filters: {
          entityId,
          partnerFunction,
        },
      },
      entityId,
    };
    const results = yield call(callApi, {
      endpoint: 'info/update/partner/new',
      options: {
        method: 'POST',
        body: JSON.stringify(request),
        errorMessage: 'Could not add partner',
        retryAction: action,
      },
    });

    yield put(actions.addPartnerDetailsSuccess(results));
  } catch (err) {
    yield put(actions.addPartnerDetailsFailure(err));
  }
}


function* watchGetPartner() {
  yield takeLatest(types.GET_PARTNERS_REQUEST, getPartners);
}

function* watchSavePartner() {
  yield takeLatest(types.SAVE_PARTNER_REQUEST, savePartner);
}

function* watchSavePartnerDetails() {
  yield takeLatest(types.SAVE_PARTNER_DETAILS_REQUEST, savePartnerDetails);
}

function* watchAddPartnerDetails() {
  yield takeLatest(types.ADD_PARTNER_DETAILS_REQUEST, addPartnerDetails);
}

export default [
  fork(watchGetPartner),
  fork(watchSavePartner),
  fork(watchSavePartnerDetails),
  fork(watchAddPartnerDetails),
];
